import { render } from "./FadingImageStats.vue?vue&type=template&id=5692abd5"
import script from "./FadingImageStats.vue?vue&type=script&lang=js"
export * from "./FadingImageStats.vue?vue&type=script&lang=js"
script.render = render

export default script